import React from 'react';

import { useQuery } from '@apollo/client/react';
import { useUser } from '@repo/hooks/useUser';
import { useParams } from 'react-router';

import { MainView, NoAccessView } from '@repo/ui/Views';

import SmsOverview from '../components/SmsOverview';

import SMS_REQUEST_SHOW_Q from '../gql/smsRequest_show.gql';

import { POLICIES } from '@/lib/Authorization';

const Sms = () => {
  const user = useUser();

  const params = useParams();
  const smsId = params.smsId;

  const { loading, error, data } = useQuery(SMS_REQUEST_SHOW_Q, {
    variables: {
      id: String(smsId),
    },
  });

  const view = POLICIES['sms_requests:show'](user) ? (
    <MainView
      title={loading ? `Loading...` : `SMS Segment: ${data?.smsRequest.id ?? ''}`}
      loading={loading}
    >
      <SmsOverview data={data!} loading={loading} error={error} />
    </MainView>
  ) : (
    <NoAccessView />
  );

  return view;
};

export default Sms;
